module.exports = __webpack_public_path__ + "static/media/course-total-unit.8a02320d.svg";